import { getHost, getPathname } from '@bridebook/web/app-basic/lib/app/selectors';
import { useSelector } from '@bridebook/web/app-basic/lib/utils';
import { FC, memo } from 'react';
import SocialSharingComponent from './social-sharing.component';
import { SocialSharingProps } from './social-sharing.types';

const SocialSharingContainer: FC<SocialSharingProps> = ({
  info,
  socialShareAnalytics,
  pinImage,
  description,
  itemLink,
}) => {
  const host = useSelector(getHost);
  const pathname = useSelector(getPathname);

  return (
    <SocialSharingComponent
      info={info}
      socialShareAnalytics={socialShareAnalytics}
      pinImage={pinImage}
      itemLink={itemLink}
      host={host}
      pathname={pathname}
      description={description}
    />
  );
};

export const SocialSharing = memo(SocialSharingContainer);
